import React, { useEffect, useState } from "react";
import "bootstrap/dist/js/bootstrap.bundle";
import displayToastMessage from "../../../../src/components/Common/Alert/displayToastMessage";
import "../../../../src/styles/userManagement.css";
import {Modal} from "@appkit4/react-components/modal"
import ModalFooter from "@appkit4/react-components/esm/modal/ModalFooter";
import {Select} from "@appkit4/react-components/select"
import PropTypes from 'prop-types'
import APIService from "../../../services/apiAxiosService";
import useHttp from "../../../hooks/useHttp.js";
import {Table, Column} from "@appkit4/react-components/table";
import { Input } from "@appkit4/react-components/field";
import { Pagination } from "@appkit4/react-components/pagination";
function UserManagement(props) {
  const [userId, setUserId] = useState();
  const [showUpdateModel, setShowUpdateModel] = useState(false);
  const [org, setOrg] = useState("");
  const [indicator, setIndicator] = useState(false);
  const [role, setRole] = useState("");
  const [roleId, setRoleId] = useState("");
  const [orgId, setOrgId] = useState("");
  const [selectUser, setSelectUser] = useState([]);
  const [errorUserMessage, setErrorUserMessage] = useState("");
  const [isErrorMessageShown, setIsErrorMessageShown] = useState(false);
  const [initialSelectedUsers, setInitialSelectedUsers] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [search, setSearch] = useState("");
  const [filter, setFilter] = useState([]);
  const [current, setCurrent] = useState(1);
  const [totalPage, setTotalPage] = useState(500);
  const { sendRequest: getUserRecordsById } = useHttp();
  const { sendRequest: assignUsers } = useHttp();

  let {
    user,
    handleDelete,
    loading,
    userList,
    reloadData,
    modalVisible,
    setmodalVisible,
    handleCancel
  } = props;

  const getUsersDetailsById = async (orgId, roleId) => {
    getUserRecordsById(APIService.getUserRecordsById(orgId, roleId), (result) => {
      let sub_array = result.MSG;
      let update_array = [];
      sub_array.map((value) => {
        return update_array.push(value.user_id);
      });
      setSelectUser(update_array);
      setInitialSelectedUsers(update_array);
    })
  };

  function findDeselectedItem(CurrentArray, PreviousArray) {
    let CurrentArrSize = CurrentArray.length;
    let PreviousArrSize = PreviousArray.length;
    let deletedElements = [];
    let addedElements = [];
    // loop through previous array
    for (let i = 0; i < PreviousArrSize; i++) {
      // look for same thing in new array
      if (CurrentArray.indexOf(PreviousArray[i]) == -1) {
        deletedElements.push(PreviousArray[i]);
      }
    }

    for (let j = 0; j < CurrentArrSize; j++) {
      if (PreviousArray.indexOf(CurrentArray[j]) == -1) {
        addedElements.push(CurrentArray[j]);
      }
    }

    return [deletedElements, addedElements];
  }

  const handleUpdate = async () => {
      if(selectUser.length == 0 ) {
      setErrorUserMessage("Please select Users");
      setIsErrorMessageShown(true);
      return false;
    }

    setIndicator(true);
    // initialSelectedUsers
    // selectUser
   
    let addedAndDeleted = findDeselectedItem(selectUser, initialSelectedUsers);
    try {
      let userData = [];

        addedAndDeleted[0]?.map((item, index) => {
          userData.push({
            orgId: orgId,
            roleId: roleId,
            userId: item,
            flag: "unchecked",
            email:sessionStorage.getItem("email"),

          });
        });

        addedAndDeleted[1]?.map((item, index) => {
          userData.push({
            orgId: orgId,
            roleId: roleId,
            userId: item,
            flag: "checked",
            email:sessionStorage.getItem("email"),

          });
        });
      assignUsers(APIService.assignUsers(userData), (data) => {
        if (data.CODE) {
          if (showUpdateModel) {
            document.body.style.overflow = "unset";
          }
          setIndicator(false);
          setShowUpdateModel(false);
          setSearch("");
          reloadData();
          setTableData(user);
          setFilter(user);
          let totalPageLength = Math.ceil((user.length)/10);
            if (totalPageLength === 0) {
              totalPageLength = 1;
            }
          setTotalPage(totalPageLength);
          displayToastMessage(data.MSG, "success");
        }
      })
    } catch (error) {
      console.log("Error",error)
      setIndicator(false);
      displayToastMessage("Something went wrong!", "error");
    }
  };

  const selectUserHandler = (e) => {
    setSelectUser(e);
    setErrorUserMessage("")
  };

  const handleUpdateModel = () => {
    if (showUpdateModel) {
      document.body.style.overflow = "unset";
    }
    setShowUpdateModel(false);
  };

  useEffect(() => {
    setTableData(user);
    setFilter(user);
  }, [user]);

  useEffect(() => {
    let totalPageLength = Math.ceil((filter.length)/10);
      if (totalPageLength === 0) {
        totalPageLength = 1;
      }
      setTotalPage(totalPageLength);
  }, [filter]);

  useEffect(() => {
    const result = tableData?.filter((userList) => {
      return userList.org_name.toLowerCase().match(search.toLocaleLowerCase());
    });
    setFilter(result);
  }, [search]);

  const renderActionCell = (row) => {
    return(
      <>
        <span className="Appkit4-icon icon-edit-fill action-icon pointer" title="Add Users" onClick={() => handleEditButton(row)}></span> &nbsp;
        <span className=" Appkit4-icon icon-delete-fill action-icon pointer" title="Delete Assigned Users" onClick={() => handleDeleteButton(row)}></span>
      </>
    )
  }

  const handleEditButton = (row) => {
    setRole(row?.role_name);
    setOrg(row?.org_name);
    setOrgId(row?.org_id);
    setRoleId(row?.role_id);
    setShowUpdateModel(true);
    getUsersDetailsById(row?.org_id, row?.role_id);
  }

  const handleDeleteButton = (row) => {
    let tempUserID = row?.user_id.split(",");
    let userID = [];
    tempUserID.forEach((item) => {
      userID.push(parseInt(item));
    });
    if (row?.user_id === null) {
      displayToastMessage(
        "Cannot delete the records. No user(s) found",
        "error"
      );
    } else {
      let userData = {
        userId: userID,
        orgId: row?.org_id,
        roleId: row?.role_id,
        email: sessionStorage.getItem("email")
      };
      setUserId(userData);
      setmodalVisible(true);
    }
  }

  const sortFuncForOrder1 = (a, b) => {
    const firstOrderId = (a.org_name).charAt(1);
    const secondOrderId = (b.org_name).charAt(1);
    return firstOrderId > secondOrderId ? 1 : -1;;
}

const sortFuncForOrder2 = (a, b) => {
  const firstOrderId = (a.org_name).charAt(1);
  const secondOrderId = (b.org_name).charAt(1);
  return firstOrderId < secondOrderId ? 1 : -1;;
}

  if (loading) {
    return (
      <div className="a-loading a-primary a-m-10 a-loading-24 spinner-alignment"></div>
    );
  }
  if (indicator) {
    return (
      <div className="a-loading a-primary a-m-10 a-loading-24 spinner-alignment"></div>
    );
  }
  return (
    <div className="App">
      <div className="col-lg-12 mt-3 pl-1">
            <div className="ap-table-demo menu-tableAlignment-width">
              {tableData.length > 0 ? (
                <Input
                type="text"
                title= "Search Organization"
                value={search}
                className="ap-field-wrapper-tableSearch"
                onChange={(e) => setSearch(e)}
              /> 
              ) : ""}
                <Table originalData={filter} hasTitle currentPage={current} pageSize={10}>
                    <Column field="org_name" sortKey={filter.length > 0 ? "org_name" : ""} sortFunc1={sortFuncForOrder1} sortFunc2={sortFuncForOrder2}>Organization</Column>
                    <Column field="role_name" sortKey={filter.length > 0 ? "role_name" : ""} className="roleWidth">Role</Column>
                    <Column field="user_name" sortKey={filter.length > 0 ? "user_name" : ""}>Users</Column>
                    <Column field="org_id" className="actionWidth"
                    renderCell={renderActionCell}
                    >Action</Column>
                </Table>
                {filter.length === 0 ? (
                  <div className="noData">
                  No data available in table
                  </div>
                  ) : ("")}
                <Pagination
                  defaultCurrent={1}
                  current={current}
                  total={totalPage}
                  onPageChange={(page) => setCurrent(page)}
                >
                </Pagination>
            </div>
            </div>

      <Modal
        className="baseline-modal-showcase"
        visible={showUpdateModel}
        onCancel={handleUpdateModel}
        bodyStyle={{height:"200px"}}
        footerStyle={{paddingTop:"8px", marginTop:"-8px"}}
        modalStyle={{width:"49.75rem", maxHeight:"fit-content"}}
        title="Organization Role Pair"
      >
          <form>
            <div className="row">
              <div className="col-sm-6">
                <div className="cv-input-field-container">
                  <label htmlFor="OrganizationUsers" className="cv-input-label">Organization</label>
                  <input
                    className="cv-input-field"
                    type="text"
                    id="OrganizationUsers"
                    name="organization"
                    value={org}
                  />
                </div>
              </div>
              <div className="col-sm-6">
                <div className="cv-input-field-container">
                  <label htmlFor="RoleUsers" className="cv-input-label">Role</label>
                  <input
                    className="cv-input-field"
                    type="text"
                    id="RoleUsers"
                    name="role"
                    value={role}
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12">
                <div className="cv-input-field-container">
                  <label htmlFor="Users" className="cv-input-label">
                    Users<span className="asterisk-required">*</span>
                  </label>
                  <Select
                    className="cv-input-field-edit-dropdown mb-2 border-0"
                    type="text"
                    showSearchOnToggle={true}
                    dropdownRenderMode="portal"
                    onSelect={(e) => selectUserHandler(e)}
                    value={selectUser}
                    data={userList}
                    labelKey="first_name"
                    valueKey="user_id"
                    multiple={true}
                    showSelectAll={false}
                    searchable={true}
                    searchPlaceholder="Search users"
                    placeholder="Select Users"
                  >
                  </Select>
                </div>
                <div className="cv-input-field">
                <span
                  className="form-label errorMsg"
                  style={{
                    display: isErrorMessageShown ? "block" : "none",
                  }}
                >
                  {errorUserMessage}
                </span>
              </div>
              </div>
            </div>
          </form>
        <div className="organization-container">
          <button
            type="button"
            className="cancel-button-edit-role"
            onClick={handleUpdateModel}
          >
            Cancel
            </button>
          <button
            type="submit"
            className="save-button-edit-role m-l-2"
            onClick={handleUpdate}
          >
            Save
            </button>
            </div>
      </Modal>

      <Modal
        className="baseline-modal-showcase"
        visible={modalVisible}
        onCancel={handleCancel}
        bodyStyle={{maxHeight:"280px"}}
        footerStyle={{paddingTop:"8px", marginTop:"-8px"}}
        modalStyle={{width:"49.75rem", maxHeight:"fit-content"}}
      >
        <div className="modal-title">
          Do you want to delete this user(s)?
        </div>
        <ModalFooter>
          <button
            type="button"
            className="cancel-button"
            onClick={handleCancel}
          >
            No
            </button>

          <button
            type="submit"
            className="save-button m-l-2"
            onClick={() => handleDelete(userId, setSearch)}
          >
            Yes
            </button>
        </ModalFooter>
      </Modal>
    </div>
  );
}

UserManagement.propTypes = {
  user: PropTypes.any,
  handleDelete: PropTypes.any,
  loading: PropTypes.any,
  userList: PropTypes.any,
  reloadData: PropTypes.any,
  modalVisible: PropTypes.any,
  setmodalVisible: PropTypes.any,
  handleCancel: PropTypes.any
}

export default UserManagement;
